export default "__VITE_ASSET__4e49a11a__"